<template>
    <div>
        <v-btn
            :disabled="!msuMain"
            small
            color="teal darken white--text"
            @click="dialog = true"
        >
            <v-icon
                small
            >
                {{ mdiLinkVariantPlus }}
            </v-icon>&nbsp;Add Link
        </v-btn>
        <v-dialog
            v-model="dialog"
            width="600"
        >
            <v-form
                ref="form"
                v-model="valid"
                @submit.prevent="createLink"
            >
                <v-card>
                    <v-card-title>Add Link</v-card-title>
                    <v-card-text>
                        <v-autocomplete
                            v-if="fetchProvidersData && fetchProvidersData.data && showProviderLinksData && showProviderLinksData.data"
                            ref="hospName"
                            v-model="msuAffl"
                            autocomplete="nope"
                            :items="providerLink()"
                            item-text="combinedText"
                            item-value="hosp_msu_code"
                            label="Affiliated Hospital or Clinic Name"
                            :rules="[v=>!!v||'Affiliated Hospital or Clinic Name']"
                        >
                            <!-- <template v-slot:selection="data">
                                <span style="height: 37px; margin: 0 0 2px 0; padding: 0"><v-chip class="white--text" color="teal darken-1" style="margin-right: 5px">{{ data.item.hosp_msu_code }}</v-chip>{{ data.item.hosp_name }}</span>
                            </template> -->
                            <template #item="data">
                                <p style="margin: 0 0 10px 0; padding: 10px 0 0 0; height: 40px;">
                                    <v-chip class="white--text" color="teal darken-1" style="margin: 3px 5px 0 0;">
                                        {{ data.item.hosp_msu_code }}
                                    </v-chip><span style="margin: 0; padding: 0">{{ data.item.hosp_name }}</span>
                                </p>
                            </template>
                        </v-autocomplete>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            color="error"
                            @click="dialog = false"
                        >
                            Close
                        </v-btn>
                        <v-btn
                            color="success"
                            :disabled="!valid"
                            type="submit"
                        >
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiLinkVariantPlus
} from '@mdi/js'
export default {
    props: ['msuMain'],
    data: ()=>({
        mdiLinkVariantPlus,
        valid: false,
        dialog: false,
        msuAffl: null

    }),
    computed: {
        ...mapGetters(['linkProvidersData', 'fetchProvidersData', 'showProviderLinksData'])

    },
    watch: {
        async linkProvidersData(newVal) {
            if (newVal) {
                if (newVal.status === 201) {
                    // await this.getCsrfToken()
                    this.showProviderLinks({ MSU_C: this.msuMain })
                    this.dialog = false
                }
                this.$emit('addNotif', { state: newVal.state, status: newVal.status })
            }
        },
        dialog(newVal) {
            if (newVal === false) this.$refs.form.reset()
        }
    },
    methods: {
        ...mapActions(['getCsrfToken', 'linkProviders', 'fetchProviders', 'showProviderLinks']),
        providerLink() {
            let data = this.fetchProvidersData.data.filter(item2 =>
                !this.showProviderLinksData.data.some(item1 => item1.hosp_msu_code === item2.hosp_msu_code)
            )
            data = data.filter(obj => obj.hosp_msu_code !== this.msuMain)

            return data.map(item => ({
                ...item,
                combinedText: `${item.hosp_msu_code} ${item.hosp_name}`
            }))
        },
        async getProviderLinks(MSU_C) {
            // await this.getCsrfToken()
            this.showProviderLinks({ MSU_C })
        },
        createLink() {
            this.$nextTick(async () => {
                if (this.$refs && this.$refs.hospName) {
                    this.$refs.hospName.blur()
                }
                if (this.$refs.form.validate()) {
                    // await this.getCsrfToken()
                    this.linkProviders({ MSU_MAIN: this.msuMain, MSU_AFFL: this.msuAffl })
                }
            })
        }
    }
}
</script>
